export default {
  share: {
    title: "Share Schedules",
    selectStaff: "Select Secretary or Institution",
    selectStaffPlaceholder: "Choose a secretary or institution...",
    searchStaff: "Search by name or email...",
    teamSecretaries: "Team secretaries",
    addTeamSecretaries: "Add secretaries to your team",
    institutions: "Institutions",
    availableSchedules: "Available Schedules",
    noSchedules: "You have no schedules configured.",
    configureSchedules: "Configure your schedules first",
    slotDuration: "{{minutes}} min appointments",
    alreadyShared: "Already shared",
    shareSelected: "Share Selected Schedules",
    sharedWith: "Schedules Shared With",
    noSharedYet: "You have not shared schedules with anyone yet.",
    confirmRemove: "Are you sure you want to stop sharing this schedule?",
    infoTitle: "Important Information",
    infoBody:
      "When you share schedules, selected secretaries and institutions can view and manage those schedules to assign appointments. Only the schedules you select are shared.",
    infoSecretariesTitle: "What can secretaries do?",
    infoSecretaries1: "View only the schedules you shared with them",
    infoSecretaries2: "Assign appointments in those available slots",
    infoSecretaries3:
      "They cannot see existing private or insurance appointments",
    infoSecretaries4: "They cannot overlap already scheduled appointments",
    infoAccessTitle: "Access control",
    infoAccess1: "You can revoke access at any time",
    infoAccess2: "Already assigned appointments remain",
    infoAccess3: "Secretaries only see basic information",
    infoAccess4: "You keep full control of your schedule",
    groupedHint: "Grouped by person; within each, by day and time.",
    toastSelectSchedule: "Select at least one schedule to share",
    toastSelectSecretary: "Select a secretary",
    toastShared: "Schedules shared successfully",
    toastRemoved: "Schedule removed from shared successfully",
  },
  gate: {
    title: "Validation pending",
    body: "Your professional account is not yet enabled. Complete your profile in Settings and upload front and back ID photos so administration can validate you.",
    goSettings: "Go to Settings",
    goHome: "Go to main menu",
  },
  admin: {
    title: "Administration panel",
    back: "Back to home",
    professionals: "Professionals",
    whitelist: "Whitelist",
    email: "Email",
    name: "Name",
    enabled: "Enabled",
    actions: "Actions",
    viewDni: "View ID",
    addEmail: "Add email",
    whitelistHelp:
      "Emails allowed to register as professionals. The email must match exactly (case insensitive).",
    toastInvalidEmail: "Enter a valid email.",
    toastEmailAdded: "Email added to the list.",
    toastEmailRemoved: "Email removed from the list.",
    toastUpdateError: "Could not update",
    toastEnabled: "Professional enabled",
    toastDisabled: "Professional disabled",
    notUploaded: "Not uploaded",
    noFrontPhoto: "No front photo.",
    noBackPhoto: "No back photo.",
    license: "License",
    specialty: "Specialty",
    phone: "Phone",
    operates: "Operates",
    emailPlaceholder: "email@example.com",
  },
  register: {
    emailRequired: "Email is required",
    emailInvalid: "Email is not valid",
    nameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    phoneRequired: "Phone is required",
    passwordMin: "Password must be at least 6 characters",
    passwordMismatch: "Passwords do not match",
    termsRequired: "You must accept the terms and conditions to continue",
    specializationRequired: "Specialization is required for doctors",
    licenseRequired: "License number is required for professionals",
    orgNameRequired: "Hospital/institution/association name is required",
    createError: "Error creating user. Please try again.",
    registrationNotAllowed:
      "You will soon be able to use this email to register on our platform",
    successProfessional:
      "Professional account created successfully! Redirecting to the main menu...",
    successManualLogin:
      "Account created successfully. Please sign in manually.",
    emailExists: "This email is already registered. Try signing in.",
    invalidEmailFormat: "Invalid email format.",
    successRole: "{{role}} account created successfully! Signing you in...",
    personalInfo: "Personal information",
    basicInfo: "Basic information",
    yourName: "Your first name",
    yourLastName: "Your last name",
    specializationPlaceholder: "e.g. Cardiology, Pediatrics, General Medicine",
    licensePlaceholder: "e.g. MD 123456",
    associationInfo: "Association information",
    institutionInfo: "Institution information",
    associationName: "Association name *",
    hospitalName: "Hospital/clinic name *",
    orgPlaceholder: "e.g. Central Hospital, San José Clinic",
    passwordPlaceholder: "At least 6 characters",
    confirmPasswordPlaceholder: "Repeat password",
    institutionLabel: "Institution",
    genericError: "Registration failed. Please try again.",
    roleDoctor: "Independent medical professional",
    roleInstitution: "Hospital, clinic, or medical center",
    roleAssociation: "Medical or professional association",
    roleSecretary: "Secretary at a medical institution",
    rolePatient: "Person seeking medical care",
    roleDoctorShort: "doctor",
    roleInstitutionShort: "institution",
    roleAssociationShort: "association",
    roleSecretaryShort: "secretary",
    rolePatientShort: "patient",
    firstName: "First name *",
    lastName: "Last name *",
    phone: "Phone *",
    password: "Password *",
    confirmPassword: "Confirm password *",
    acceptTerms: "I accept the terms and conditions",
    acceptTermsPrefix: "I accept the",
    termsLink: "terms and conditions",
    consentMarketing:
      "I agree to receive text messages and/or emails",
    creatingAccount: "Creating account...",
    createAccountAs: "Create account as {{role}}",
    roleInstitutionLabel: "Institution",
    submit: "Register",
    hasAccount: "Already have an account?",
    loginLink: "Sign in",
    accountType: "Account type *",
    rolePatientLabel: "Patient",
    roleDoctorLabel: "Doctor",
    roleAssociationLabel: "Association",
    roleSecretaryLabel: "Secretary",
    professionalInfo: "Professional information",
    specialization: "Specialty *",
    licenseNumber: "License number *",
    security: "Security",
    termsSection: "Terms and consent",
    termsTitle: "Terms and Conditions",
    termsLegal: {
      acceptanceTitle: "1. Acceptance of Terms",
      acceptanceBody:
        "By accessing and using this platform, you agree to be bound by these terms and conditions of use. If you do not agree with any part of these terms, you must not use our services.",
      serviceTitle: "2. Use of the Service",
      serviceBody:
        "You agree to use the platform only for lawful purposes and in accordance with these terms. You must not use the service in any way that could damage, disable, overload, or compromise our systems.",
      accountTitle: "3. User Account",
      accountBody:
        "You are responsible for maintaining the confidentiality of your account and password. You accept responsibility for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account.",
      privacyTitle: "4. Privacy and Data Protection",
      privacyBody:
        "We respect your privacy and protect your personal data in accordance with our privacy policy. By using our services, you consent to the collection and use of information in accordance with that policy.",
      responsibilitiesTitle: "5. User Responsibilities",
      responsibilitiesBody:
        "You are responsible for providing accurate and up-to-date information. You must not provide false, misleading, or fraudulent information. Any violation of these terms may result in immediate termination of your account.",
      liabilityTitle: "6. Limitation of Liability",
      liabilityBody:
        "To the maximum extent permitted by law, we shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use our services.",
      modificationsTitle: "7. Modifications to the Terms",
      modificationsBody:
        "We reserve the right to modify these terms at any time. Modifications will take effect immediately upon publication. Your continued use of the service after such modifications constitutes your acceptance of the new terms.",
      contactTitle: "8. Contact",
      contactBody:
        "If you have any questions about these terms and conditions, you can contact us through the means provided on our platform.",
    },
    email: "Email *",
    emailPlaceholder: "you@email.com",
    phonePlaceholderExample: "+1 555 123-4567",
  },
  appointments: {
    assigning: "Assigning appointment…",
    booking: "Booking appointment…",
    selectDate: "Select Date",
    patientData: "Patient Information",
    forPatient: "For: {{name}}",
    restrictedAccess: "Restricted Access",
    restrictedAccessLower: "Restricted access",
    fillRequired: "Please complete all required fields (including reason)",
    bookSuccess: "Appointment booked successfully",
    bookError: "Error booking appointment. Please try again.",
    assignError: "Error assigning appointment. Please try again.",
    noSlots: "No available time slots to assign.",
    noSlotsLeftToday: "No time slots left for today",
    noSlotsForDate: "No time slots for this date",
    slotInPast: "That time has already passed. Choose one from the current time onwards.",
    searchEmail: "Please enter an email to search",
    searchError: "Error searching for patient. Please try again.",
    inviteEmail: "Please enter an email to send the invitation",
    inviteInvalidEmail: "Please enter a valid email",
    inviteSuccess: "Invitation sent successfully by email",
    inviteError: "Error sending invitation. Please try again.",
    myAppointments: "All My Appointments",
    assignedHistory: "Assigned Appointments History",
    updateError: "Error updating appointment",
    cancelError: "Error cancelling appointment",
    next7Days: "Next 7 days",
    totalSeen: "Total seen",
    schedulesConfigured: "Schedules configured",
    upcoming: "Upcoming appointments",
    available: "Available",
    notes: "Notes:",
    reason: "Reason:",
    dateTime: "Date and time:",
    confirmCancel: "Are you sure you want to cancel {{name}}'s appointment?",
    confirmCancelGeneric: "Are you sure you want to cancel?",
    confirmCancelDesc: "This will free up the slot for other patients.",
    confirmYes: "Yes, cancel",
    cancelAppointment: "Cancel appointment",
    cancelSuccess: "Appointment cancelled successfully",
    cancelDaysTitle: "Cancel day(s)",
    enableCancellation: "Enable cancellation",
    cancellationOn: "On",
    cancellationOff: "Off",
    cancellationEnabledHint: "Select the days in the calendar above",
    cancellationDisabledHint: "Turn on the switch to cancel one or more days",
    selectDaysLegend: "Choose the days to cancel in the calendar above",
    cancellationReason: "Reason",
    cancellationReasonPlaceholder: "E.g. medical emergency, vacation, etc.",
    notifyPatients: "Notify my patients",
    notifyPatientsHint: "Your patients will be notified via email",
    reasonRequired: "A cancellation reason is required",
    selectDatesRequired: "You must select at least one day",
    noAppointmentsToCancel: "There are no booked appointments on the selected days",
    bulkCancelSuccess: "Appointments cancelled and patients notified",
    bulkCancelConfirmDesc: "{{count}} appointment(s) will be cancelled and each affected patient will receive an email.",
    selectedDaysCount: "{{count}} day(s) selected — {{appointments}} appointment(s) affected",
    cancelFromEmailTitle: "Cancel appointment",
    cancelFromEmailDesc: "You are about to cancel the following appointment:",
    invalidCancelLink: "The cancellation link is invalid.",
    alreadyCancelled: "This appointment has already been cancelled or cannot be modified.",
    slotTaken:
      "This time slot is already taken. Please select another available time.",
    patientSlotTaken: "You already have an appointment booked at this time.",
    noScheduled: "You have no scheduled appointments.",
    doctorsOnly: "This section is for doctors only.",
    assignRolesOnly:
      "Only doctors, secretaries, and institutions can assign appointments.",
    doctorPageTitle: "My appointments",
    doctorPageSubtitle: "Review all your scheduled appointments and availability",
    patientPageSubtitle: "Review your scheduled medical appointments and history",
    today: "Today",
    totalAppointmentsLabel: "Total appointments",
    completedLabel: "Completed",
    createdOn: "Created on",
    unknownDoctor: "Unknown doctor",
    noUpcomingScheduled: "You have no scheduled appointments",
    scheduledCount: "{{count}} scheduled appointments",
    noDaySchedule: "You have no schedules configured for this day",
    patientFallback: "Patient",
    defaultPatientName: "this patient",
    appointmentNotFound: "Appointment to cancel was not found",
    doctorNotAvailable: "This professional is not available to receive appointments.",
    unregisteredPatientHistory:
      "This patient is not registered in the system. Clinical history cannot be created for unregistered patients.",
    viewMoreAppointments: "View more appointments",
    bookAppointment: "Book appointment",
    bookFirstAppointment: "Book your first appointment",
    noRegisteredAppointments: "You have no registered appointments",
    recentHistory: "Recent history",
    noAppointmentHistory: "You have no appointment history",
    hospital: "Hospital",
    statusOccupied: "Occupied",
    statusAvailable: "Available",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
    statusUnknown: "No status",
    assignedBySecretary: "Assigned by {{name}}",
    statusConfirmed: "Confirmed",
    secretaryFallback: "Secretary",
  },
  scheduleConfig: {
    addTitle: "Add New Schedule",
    configuredTitle: "Configured Schedules",
    selectDay: "Select at least one day",
    selectDate: "Select at least one date on the calendar",
    addedSuccess: "Schedules added successfully",
    blockedSuccess: "Days blocked successfully",
    occasionalAdded: "Occasional schedule added",
    configureLink: "Configure schedules",
    blockReason: "Block reason",
    blockReasonPlaceholder: "e.g. Holiday, Vacation, Conference...",
    confirmDelete: "Are you sure you want to delete the selected schedule?",
    pageTitle: "Schedule configuration",
    pageSubtitle: "Define your office hours, special dates, and days without appointments",
    blockError: "Error blocking dates",
    occasionalError: "Error adding occasional schedule",
    appointmentType: "Appointment type",
    startTime: "Start time",
    endTime: "End time",
    slotDurationLabel: "Appointment duration (minutes)",
    blockDates: "Block dates",
    addSchedule: "Add schedule",
    configuredHint: "Regular by day; occasional and blocked by date.",
    noSchedulesYet: "You have no schedules configured yet",
    habitualSchedules: "Regular schedules",
    occasionalSchedules: "Occasional schedules",
    blockedDays: "Blocked days",
    dateCount: "{{count}} date",
    datesCount: "{{count}} dates",
    scheduleCount: "{{count}} schedule",
    schedulesCount: "{{count}} schedules",
    slotsOfMinutes: "({{minutes}} min appointments)",
    duration15: "15 minutes",
    duration30: "30 minutes",
    duration45: "45 minutes",
    duration60: "1 hour",
    duration90: "1.5 hours",
    duration120: "2 hours",
    startBeforeEnd: "Start time must be earlier than end time",
    blockReasonRequired: "Enter the reason for blocking (e.g. holiday, vacation)",
    typeHabitualHint: "Recurring schedule by day of the week.",
    typeOccasionalHint: "Appointments only on specific dates you choose.",
    typeBlockedHint: "No appointments on those dates (holidays, vacation, conferences, etc.).",
    billingLinkHint: "To issue electronic invoices you need to configure AFIP.",
    configureBilling: "Configure billing",
    shareSecretaryHint:
      "Remember to share your schedules with your secretary so they can manage your calendar.",
    shareSchedulesLink: "Share schedules",
    scheduleTypeLabel: "Schedule type",
    daysOfWeekLabel: "Days of the week",
    addSomeSchedulesError: "Error adding some schedules:\n\n{{errors}}",
  },
  clinical: {
    backToSearch: "Back to search",
    patientNotFoundTitle: "Patient not found",
    patientNotFoundDesc:
      "We couldn't find this patient's clinical history. They may not be registered in the system.",
    restrictedAccess: "Restricted Access",
    notesRequired: "Please enter consultation notes",
    saveSuccess: "Clinical record saved successfully",
    saveError: "Error saving clinical record: {{message}}",
    uploadError: "Error uploading images: {{message}}",
    noEdit: "Clinical records cannot be edited. You can only create new ones.",
    searchResults: "Search Results",
    consultationNotes: "Consultation Notes",
    studySaved: "Study saved successfully",
    studyDeleted: "Study deleted",
    commentUpdated: "Comment updated",
    selectImage: "Select an image file",
    imageTooLarge8: "Image cannot exceed 8 MB",
    chooseImage: "Choose an image to upload",
    notesPlaceholder: "Describe symptoms, diagnosis, recommended treatment, observations, etc.",
    attachmentsOptional: "Attached images (optional)",
    selectedImages: "Selected images:",
    searchPatient: "Search by email, ID, first or last name...",
    viewHistory: "View history",
    loadingHistory: "Loading clinical history...",
    historyTitle: "Clinical history",
    nameLabel: "Name",
    patientInfo: "Patient information",
    consultationDetails: "Consultation details",
    patientLabel: "Patient:",
    patientNotFound: "Not found",
    digitizationDate: "Digitization date:",
    notesHint: "Include all relevant information from the medical consultation.",
    viewPatientBackground: "View patient background",
    patientBackgroundTitle: "Patient background",
    patientInfoOf: "Information for {{name}}",
    dni: "ID number",
    healthInsurance: "Health insurance / prepaid plan",
    affiliateNumber: "Member number",
    plan: "Plan",
    emergencyContact: "Emergency contact",
    informedConsentSubtitle: "Informed consent",
    dateUnavailable: "Date unavailable",
    loadingPatient: "Loading patient information...",
    newHistoryTitle: "New Clinical Record",
    saveHistory: "Save clinical record",
    uploadHint: "Drag images here or click to select",
    digitizeButton: "Digitize Records",
    digitizeTitle: "Digitize Records",
    digitizeDetails: "Physical record digitization",
    digitizeNotes: "Notes (optional)",
    digitizeNotesPlaceholder: "Optional description of the physical record (e.g. digitized pages, general observations, etc.)",
    digitizeNotesHint: "You can add a brief description. Photos or scans of the physical record are the main content.",
    digitizeImages: "Physical record images *",
    digitizeUploadHint: "Photograph or scan the pages of the physical clinical record and upload them here",
    digitizeImagesRequired: "Upload at least one image of the physical record",
    digitizeDefaultNotes: "Digitized physical record",
    digitizeSave: "Save digitization",
    recordDate: "Record date:",
  },
  healthHistory: {
    title: "Health data evolution",
    titleOf: "Evolution for {{name}}",
    viewEvolution: "View evolution",
    loadError: "Could not load health history.",
    empty: "No historical records yet. They are saved automatically when the patient updates their health data.",
    bmi: "BMI",
    weightEvolution: "Weight evolution:",
    date: "Date",
    habits: "Habits",
    noChange: "no change",
  },
  profile: {
    officeAddress: "Office address",
    officeAddressHint:
      "Shown to patients in search results along with the distance from their home.",
    settingsTitle: "Settings",
    tabInfo: "Information",
    tabStudies: "My Studies",
    tabDependents: "Family",
    tabPatientData: "My health",
    patientDataTitle: "My health data",
    patientDataIntro:
      "This is the information the professional treating you sees when you book an appointment as a patient. It is not shown on your public profile.",
    saved: "Data saved",
    saveError: "Could not save the data",
    tabSubscription: "Subscription",
    tabTeam: "Team",
    tabBilling: "Billing",
    tabConfig: "Settings",
    bookingHorizonTitle: "Appointment visibility",
    bookingHorizonIntro: "Set how far in advance your patients can book appointments on your schedule.",
    bookingHorizonLabel: "Maximum booking window (patients)",
    bookingHorizonOption: "{{days}} days",
    bookingHorizonHint: "Patients will only see available dates within this range when booking.",
    configSaved: "Settings saved",
    configSaveError: "Error saving settings",
    changePassword: "Change password",
    fileTooLarge: "File cannot exceed 5 MB",
    preferences: "Preferences",
    receiveNotifications: "Receive notifications",
    passwordPlaceholder: "••••••••",
    teamTitle: "Team",
    required: "* Required",
    select: "Select",
    yes: "Yes",
    no: "No",
    years: "years",
    name: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    phoneOptional: "Phone (optional)",
    contact: "Contact",
    address: "Address",
    street: "Street and number",
    floor: "Floor",
    apt: "Apt",
    city: "City",
    province: "State/Province",
    postalCode: "Postal code",
    personalData: "Personal information",
    dni: "ID number",
    birthDate: "Date of birth",
    gender: "Gender",
    age: "Age",
    genderMale: "Male",
    genderFemale: "Female",
    genderOther: "Other",
    genderPreferNot: "Prefer not to say",
    phonePatientHint: "Used for your appointments and so the medical team can reach you. You may include country code.",
    phoneDoctorHint: "This number appears in search and when patients book with you.",
    phoneInstitutionHint: "This number appears on the institution's public page.",
    phoneAssociationHint: "This number appears on the association's public page. Email is edited above with name and last name.",
    healthInsurance: "Health insurance",
    healthInsuranceNumber: "Number",
    plan: "Plan",
    healthData: "Health information",
    height: "Height (cm)",
    weight: "Weight (kg)",
    phHeight: "e.g. 170",
    phWeight: "e.g. 75",
    bloodType: "Blood type",
    bloodFactor: "Factor",
    smoking: "Smoking",
    sedentary: "Sedentary lifestyle",
    toxics: "Substance use",
    antecedents: "Medical history",
    antecedentsPlaceholder: "Surgeries, permanent medication, or other relevant information for your doctor",
    disability: "Disability",
    disabilityType: "Type",
    disabilityDetail: "Please provide details:",
    disabilityDetailPlaceholder: "Describe your situation",
    disabilityNone: "None",
    disabilitySensory: "Sensory (visual and hearing)",
    disabilityPhysical: "Physical",
    disabilityMental: "Mental",
    disabilityIntellectual: "Intellectual",
    emergencyContact: "Emergency contact",
    emergencyOther: "Other",
    emergencyOtherPlaceholder: "Other contact method",
    registration: "Registration",
    createdAt: "Created:",
    updatedAt: "Last updated:",
    professionalData: "Professional information",
    abbreviation: "Title",
    specialty: "Specialty",
    licenseNumber: "License number",
    identityVerification: "Identity verification",
    identityHint: "We ask for this to verify you are a medical professional. Images are confidential.",
    dniFront: "ID photo (front)",
    dniBack: "ID photo (back)",
    uploadImage: "Upload image",
    uploading: "Uploading...",
    languages: "Languages spoken",
    languagesMax: "(max. 4)",
    profilePhoto: "Profile photo",
    changePhoto: "Change photo",
    profilePhotoHint: "This image will appear on your public profile.",
    institutionData: "Institution information",
    associationData: "Association information",
    fantasyName: "Display name",
    fantasyNameHint: "(visible to patients and professionals)",
    institutionType: "Institution type",
    institutionLogo: "Institution logo",
    associationLogo: "Association logo",
    logoFormatHint: "JPG, PNG or GIF format. Maximum size 5 MB.",
    uploadLogo: "Upload logo",
    instConsultorio: "Private office",
    instPoli: "Multi-office clinic",
    instClinica: "Clinic",
    instSanatorio: "Hospital",
    instOtro: "Other",
    publicDescription: "Public description",
    publicDescriptionHint: "This text will appear on the association's public page, below contact information.",
    associatedTo: "Associated with:",
    viewAssociation: "View association",
    passwordHint: "Leave blank to keep current password. Current password cannot be recovered here for security reasons.",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    passwordBlankPlaceholder: "Leave blank to keep unchanged",
    passwordRepeatPlaceholder: "Repeat new password",
    passwordMismatch: "Passwords do not match",
    hidePassword: "Hide password",
    showPassword: "Show password",
    saveChanges: "Save changes",
    saving: "Saving...",
    goHome: "Go to home",
    loadError: "There was an error loading user data:",
    teamIntro: "Invite secretaries to manage your appointments. A temporary password will be generated for you to share. They will be asked to change it on first login.",
    secretaryAdded: "Secretary added successfully.",
    secretaryAddError: "Could not add secretary.",
    secretaryRemoved: "Secretary removed from team.",
    secretaryRemoveError: "Could not remove secretary.",
    tempPasswordFor: "Temporary password generated for {{name}}",
    tempPasswordNew: "the new secretary",
    tempPasswordShare: "Share this password manually. They must change it when signing in to continue.",
    passwordLabel: "Password:",
    adding: "Adding...",
    addSecretary: "Add secretary",
    assignedSecretaries: "Assigned secretaries",
    loadSecretariesError: "Error loading secretaries:",
    secretaryDefault: "Secretary",
    noSecretaries: "You haven't added secretaries yet. Use the form above to invite them to your team.",
    tel: "Tel:",
    billingIntro: "Manage your billing settings here.",
    viewInvoices: "View invoices",
    configureAfip: "Configure AFIP credentials",
    appointmentDuration: "Appointment duration",
    consultationCost: "Consultation fee",
    mpToken: "Mercado Pago token",
    mpTokenTooltip: "The access token is a string that identifies your Mercado Pago account and authenticates API requests. You can find it in your Mercado Pago account settings, under credentials.",
    subscriptionTitle: "Subscription",
    subscriptionIntro: "Manage your recurring subscription. Keep your account active with automatic monthly payments.",
    serviceStatusLabel: "Service status",
    serviceActive: "Active 💚",
    serviceInactive: "Inactive 💔",
    serviceActiveHint: "Your account is enabled on the platform. You can receive appointments and use all features.",
    serviceInactiveHint: "Your account is not enabled yet. Once payment is confirmed, the administrator will activate your service.",
    subscriptionLoadError: "Error loading subscription",
    subscriptionCreateError: "Error creating subscription",
    paymentUrlError: "Could not get payment URL",
    subscriptionStatus: "Subscription status",
    price: "Price:",
    billingCycle: "Billing cycle:",
    monthly: "Monthly",
    yearly: "Yearly",
    nextBilling: "Next charge:",
    lastPayment: "Last payment:",
    statusActive: "Active",
    statusPending: "Pending",
    statusPaused: "Paused",
    statusCancelled: "Cancelled",
    statusInactive: "Inactive",
    pendingHint: "Your subscription is pending approval. Complete payment on Mercado Pago to activate it.",
    activeHint: "✓ Your subscription is active. Payments will be processed automatically according to your billing cycle.",
    processing: "Processing...",
    renewSubscription: "Renew subscription",
    createSubscription: "Create subscription",
    noActiveSubscription: "You don't have an active subscription. Create a recurring subscription to keep your account active.",
    debitedMonthly: "Charged monthly",
    subscribe: "Subscribe",
    phDni: "e.g. 12345678",
    phPhone: "e.g. +1 555 123-4567",
    phStreet: "e.g. 123 Main St",
    phFloor: "e.g. 2",
    phApt: "e.g. A",
    phCity: "e.g. New York",
    phProvince: "e.g. NY",
    phPostal: "e.g. 10001",
    phInsurance: "e.g. Blue Cross, Aetna",
    phAffiliate: "Member ID",
    phPlan: "e.g. 210, 310",
    phSpecialty: "e.g. Cardiology",
    phLicense: "e.g. MD 12345",
    phInstitution: "e.g. San Martin Medical Center",
    phAssociation: "e.g. Medical Association",
    phDescription: "e.g. We are an association of professionals...",
  },
  install: {
    title: "Install app",
    subtitle: "Install {{brand}} as an app",
    heroTitle: "Install {{brand}} as an app",
    heroSubtitle: "Add the platform to your desktop or home screen for quick access, instant notifications, and a distraction-free experience.",
    installApp: "Install app",
    installFromBrowser: "Install from browser",
    waitingAvailability: "Waiting for availability…",
    noAutoButton: "If your browser doesn't show the automatic button, follow the steps below.",
    stepsTitle: "Quick install for your device",
    stepsSubtitle: "Follow these steps and in seconds you'll have {{brand}} as an app.",
    alreadyInstalled: "Already installed {{brand}}?",
    alreadyInstalledHint: "You can pin it to your taskbar or move the icon wherever is most convenient. Contact support if you need help.",
    alsoWeb: "You can also return home to keep using the web version.",
    goHome: "Go to home",
    badgeInstalled: "Already installed on this device",
    badgeAvailable: "Install available",
    followSteps: "Follow these steps and in seconds you'll have {{brand}} as an app.",
    platformSteps: {
      ios: {
        1: "Open this page in Safari.",
        2: "Tap the Share button (square with arrow icon).",
        3: "Scroll and choose “Add to Home Screen”.",
        4: "Confirm the name and tap “Add”.",
      },
      android: {
        1: "Open this page in Chrome.",
        2: "Tap the ⋮ menu in the top-right corner.",
        3: "Choose “Add to Home screen”.",
        4: "Confirm to create the shortcut.",
      },
      desktop: {
        1: "In Chrome, click the install icon (monitor with arrow) to the right of the address bar.",
        2: "Confirm installation to add the app to your desktop and start menu.",
        3: "In Edge, use ⋯ menu > “Apps” > “Install this site as an app”.",
      },
    },
    guides: {
      chromeDesktop: {
        title: "Chrome on desktop",
        location: "Install icon to the right of the address bar.",
        step1: "Click the Install app icon (monitor with arrow or + symbol).",
        step2: "When the “Install app” modal appears, confirm with Install.",
        note: "If you don't see the icon, open the ⋮ menu and look for “Install”.",
      },
      edgeDesktop: {
        title: "Microsoft Edge",
        location: "⋯ menu in the top-right corner.",
        step1: "Click ⋯ and choose Apps.",
        step2: "Select “Install this site as an app”.",
        step3: "Confirm with Install.",
      },
      chromeAndroid: {
        title: "Chrome on Android",
        location: "⋮ menu at the top right.",
        step1: "Tap the browser ⋮ menu.",
        step2: "Choose “Install app” or “Add to Home screen”.",
        step3: "Confirm with Add.",
      },
      safariIos: {
        title: "Safari on iPhone / iPad",
        location: "Share button (square with arrow) on the bottom bar.",
        step1: "Tap the Share icon.",
        step2: "Scroll and choose “Add to Home Screen”.",
        step3: "Confirm with Add.",
      },
      safariDesktop: {
        title: "Safari on macOS",
        location: "“File” menu in the menu bar.",
        step1: "In Safari, open the File menu.",
        step2: "Select “Add to Dock”.",
        step3: "Confirm and the shortcut will appear in your Dock.",
        note: "This option is available on macOS Ventura or later.",
      },
      firefoxAndroid: {
        title: "Firefox on Android",
        location: "⋮ menu at the top right.",
        step1: "Open the ⋮ menu.",
        step2: "Choose “Add to Home screen”.",
        step3: "Confirm with Add.",
      },
      operaAndroid: {
        title: "Opera / Samsung Internet",
        location: "Browser menu at the bottom or top.",
        step1: "Open the browser menu.",
        step2: "Select “Add to Home screen” or “Install app”.",
        step3: "Confirm the action.",
      },
      otherAndroid: {
        title: "Other browser on Android",
        location: "Browser menu.",
        step1: "Open the browser menu.",
        step2: "Look for “Add to Home screen” or “Install app”.",
        step3: "Follow the steps requested.",
      },
      otherDesktop: {
        title: "Other browser on desktop",
        location: "Main browser menu.",
        step1: "Look in the menu for Install, App, or Add to desktop.",
        step2: "Follow the browser steps to confirm installation.",
        note: "Some browsers require Chrome or Edge to install the PWA.",
      },
      default: {
        title: "Quick install",
        location: "Look in your browser for Install app or Add to Home Screen.",
        step1: "Open the browser's main menu.",
        step2: "Select install or add to home screen.",
        step3: "Confirm when the browser prompts you.",
      },
    },
  },
  messaging: {
    title: "Bulk messaging",
    subtitle: "Send WhatsApp or email messages to multiple users",
    accessRequired: "Access required",
    sendType: "Send Type",
    messageContent: "Message Content",
    sentMessages: "Sent Messages",
    imageTooLarge: "Image is too large. Maximum 5MB.",
    uploadError: "Error uploading image: {{message}}",
    subject: "Subject *",
    subjectPlaceholder: "Message subject",
    message: "Message *",
    messagePlaceholder: "Write your message here...",
    availableUsers: "Available users",
    selected: "Selected",
    validForSend: "Valid for sending",
    noContactData: "No contact data",
    searchUsers: "Search by name, email, or phone...",
    cancellationType: "Cancellation type *",
    selectCancellation: "Select a cancellation type",
    cancelVacation: "Appointment cancellation for vacation",
    cancelDate: "Appointment cancellation for date",
    dateFrom: "From date *",
    dateTo: "To date *",
    date: "Date *",
    messagePreview: "Message preview",
    emailPreview: "Email preview",
    subjectLabel: "Subject:",
    messageLabel: "Message:",
    loadMessagesError: "Error loading messages",
    loadMessagesErrorDetail: "Error loading received messages",
    markReadError: "Error marking as read",
    sendMessagesError: "Error sending messages",
  },
  billing: {
    configureAfip: "You must configure AFIP before issuing invoices",
    invoiceCreated: "Invoice created successfully",
    invoiceError: "Error creating invoice",
    pdfError: "Error generating PDF",
    downloadError: "Error downloading PDF",
    discardError: "Error discarding appointment",
    issuerData: "Issuer Information",
    clientData: "Client Information",
    totals: "Totals",
    afipInfo: "AFIP Information",
    title: "Billing",
    subtitle: "Manage your electronic invoices",
    searchPlaceholder: "Patient, number...",
    status: "Status",
    all: "All",
    pending: "Pending",
    authorized: "Authorized",
    rejected: "Rejected",
    from: "From",
    to: "To",
    noInvoices: "No invoices issued",
    patient: "Patient:",
    date: "Date:",
    time: "Time:",
    type: "Type:",
    invoiceType: "Invoice type",
    invoiceC: "Invoice C (exempt)",
    docType: "Document type",
    passport: "Passport",
    docNumber: "Document number",
    subtotal: "Subtotal",
    total: "Total",
    concept: "Concept",
    invoiceDetail: "Invoice detail",
    invoiceDetailHint: "Complete information for the issued invoice",
    professional: "Professional:",
    businessName: "Business name:",
    salesPoint: "Sales point:",
    document: "Document:",
    invoiceTypeLabel: "Invoice type:",
    caeExpiry: "CAE expiry:",
    confirmDiscard: "Are you sure you want to discard this appointment? You will not be able to invoice it and it will no longer appear in the list.",
    notConfigured: "Not configured",
  },
  consent: {
    myDocuments: "My documents ({{count}})",
    docNotFound: "Document not found",
    loadError: "Error loading document",
    deleteError: "Error deleting document",
    deleteSuccess: "Document deleted successfully",
    titleContentRequired: "Please complete the document title and content",
    authRequired: "You must be signed in to save documents",
    userNotFound: "Error: Could not identify user. Please sign in again.",
    userNotInSystem: "Error: User does not exist in the system. Contact the administrator.",
    updateError: "Error updating document",
    updateSuccess: "Document updated successfully",
    createError: "Error creating document: {{message}}",
    saveSuccess: "Document saved successfully",
    saveError: "Error saving document",
    previewRequired: "Please complete title and content before preview",
    editorTitle: "Document Editor",
    viewTitle: "Document View",
    docTitle: "Document title",
    docTitlePlaceholder: "e.g. Knee surgery consent",
    docContent: "Document content",
    docContentPlaceholder: "Write the consent document content here...",
    confirmDelete: "Are you sure you want to delete this document?",
    confirmDeleteCustom: "Are you sure you want to delete this custom document?",
    confirmCancel: "Do you want to cancel the operation?",
    totalDocs: "Total documents",
    categories: "Categories",
    results: "Results",
    format: "Format",
    searchDocs: "Search documents by name, category, or description...",
    aboutDocs: "About the documents",
    recommendedUse: "Recommended use",
    loading: "Loading document...",
    helpPdf: "All documents are in PDF format",
    helpBeforeProcedure: "They must be completed before each procedure",
    helpAskDoctor: "Ask the medical professional if you have questions",
    helpSignWithDoctor: "Complete and sign in the presence of the doctor",
    helpReadFully: "It is important to read everything completely before signing",
    helpReadCarefully: "Read all information carefully",
    officialHealthDocs: "They are official documents from the Argentine health system",
    downloadForProcedure: "Download the document for the corresponding procedure",
    importantInfoTitle: "Important information",
    createdOn: "Document created on:",
    pageTitle: "Informed Consent",
    pageSubtitle:
      "Official informed consent documents for different medical procedures",
    allCategories: "All categories",
    createCustomDoc: "Create Custom Document",
    clearFilters: "Clear filters",
    documentsFoundOne: "{{count}} document found",
    documentsFoundMany: "{{count}} documents found",
    resultsForSearch: ' for "{{term}}"',
    resultsInCategory: ' in category "{{category}}"',
    noCustomDocs: "You have no custom documents",
    noDocsFound: "No documents found",
    noCustomDocsHint:
      "You have not created any custom informed consent documents yet.",
    adjustFiltersHint:
      "Try adjusting your search filters or searching with different terms.",
    createFirstDoc: "Create First Document",
    downloadDocument: "Download Document",
    customDocSubtitle: "Custom informed consent document",
    backToDocs: "Back to Documents",
    editConsentTitle: "Edit Consent Document",
    createConsentTitle: "Create Consent Document",
    editConsentSubtitle: "Edit the informed consent document",
    createConsentSubtitle: "Create a custom informed consent document",
    saving: "Saving...",
    updateDocument: "Update Document",
    saveDocument: "Save Document",
    preview: "Preview",
    edit: "Edit",
    cancel: "Cancel",
    printDocument: "Print Document",
    downloadPdf: "Download PDF",
    delete: "Delete",
    loadingEditor: "Loading editor...",
    previewSection: "Document preview",
    quill: {
      bold: "Bold",
      italic: "Italic",
      underline: "Underline",
      strike: "Strikethrough",
      orderedList: "Numbered list",
      bulletList: "Bulleted list",
      indentLess: "Decrease indent",
      indentMore: "Increase indent",
      link: "Link",
      image: "Image",
      clean: "Clear formatting",
      header: "Text style",
      headerNormal: "Normal",
      headerH1: "Heading 1",
      headerH2: "Heading 2",
      headerH3: "Heading 3",
      headerH4: "Heading 4",
      headerH5: "Heading 5",
      headerH6: "Heading 6",
      align: "Alignment",
      alignLeft: "Left",
      alignCenter: "Center",
      alignRight: "Right",
      alignJustify: "Justify",
      uploadImageError: "Error uploading image",
    },
    categoryLabels: {
      anesthesia: "Anesthesia",
      diagnostic: "Diagnostic",
      ophthalmology: "Ophthalmology",
      vascularSurgery: "Vascular Surgery",
      general: "General",
      surgery: "Surgery",
      hemotherapy: "Hemotherapy",
      rehabilitation: "Rehabilitation",
      cardiology: "Cardiology",
      custom: "Custom",
    },
    predefined: {
      anesthesiaPostop: {
        title: "Anesthesia and Postoperative Analgesia",
        description:
          "Consent for anesthetic procedures and postoperative pain management",
      },
      bronchoscopy: {
        title: "Bronchoscopy",
        description:
          "Endoscopic procedure to examine the airways",
      },
      cataractSurgery: {
        title: "Cataract Surgery",
        description: "Surgical intervention for cataract treatment",
      },
      crosectomy: {
        title: "Crosectomy",
        description: "Vascular surgical procedure",
      },
      diagnosisTreatment: {
        title: "Diagnosis and/or Treatment",
        description:
          "General consent for diagnostic and therapeutic procedures",
      },
      electromyogram: {
        title: "Electromyogram",
        description: "Study of muscle electrical activity",
      },
      limbAmputation: {
        title: "Surgical Limb Amputation",
        description: "Surgical amputation procedure",
      },
      hivTest: {
        title: "HIV Diagnostic Test",
        description: "Consent for HIV screening test",
      },
      bloodTransfusion: {
        title: "Blood Transfusion Practice",
        description: "Consent for blood transfusion",
      },
      cardioRehab: {
        title: "Cardiorespiratory Rehabilitation Program",
        description: "Cardiovascular and respiratory rehabilitation program",
      },
      stressTest: {
        title: "Graded Exercise Stress Test",
        description: "Cardiovascular stress test",
      },
      liverBiopsy: {
        title: "Hepatic Biopsy Puncture",
        description: "Liver biopsy procedure",
      },
    },
  },
  search: {
    sortDistance: "Location (nearest)",
    insurance: "Health insurance / Prepaid plan",
    allInsurances: "All",
    myInsurance: "{{name}} (your coverage)",
    acceptsInsurance: "Accepts your coverage",
    notAcceptsInsurance: "Does not accept your coverage: private appointments only",
    addInsurance: "Add your health coverage",
    noDoctorAddress: "The professional has not provided an address",
    distanceAt: "{{km}} km away, at {{address}}",
    addAddress: "Add your address to see the distance",
    title: "Search",
    searchAssociation: "Search by association name...",
    searchProfessional: "Search by name, specialty, or email...",
    searchDoctor: "Search doctor by name, specialty...",
    searchProfessionalShort: "Search professional...",
    searchAssociationLabel: "Search association",
    sortName: "Name",
    specialty: "Specialty",
    allSpecialties: "All specialties",
    institution: "Institution",
    allInstitutions: "All institutions",
    perConsultation: "per consultation",
    pageTitle: "Find a Professional",
    pageSubtitle: "Find the ideal doctor for your appointment",
    filters: "Filters",
    clearFilters: "Clear filters",
    sortBy: "Sort by:",
    hasPrivateSchedule: "Has private schedule",
    memberSince: "Member since {{year}}",
    scheduleAtInstitution: "Has schedule at {{name}}",
    bookAppointment: "Book Appointment",
    professionalsFoundOne: "{{count}} professional found",
    professionalsFoundMany: "{{count}} professionals found",
    resultsForSearch: ' for "{{term}}"',
    patientsOnly: "This section is for patients only.",
    noProfessionalsFound: "No professionals found",
    adjustFiltersHint:
      "Try adjusting your search filters or searching with different terms.",
    specializations: {
      cardiology: "Cardiology",
      dermatology: "Dermatology",
      endocrinology: "Endocrinology",
      gastroenterology: "Gastroenterology",
      gynecology: "Gynecology",
      generalMedicine: "General Medicine",
      neurology: "Neurology",
      ophthalmology: "Ophthalmology",
      orthopedics: "Orthopedics",
      pediatrics: "Pediatrics",
      psychiatry: "Psychiatry",
      traumatology: "Traumatology",
      urology: "Urology",
    },
  },
  secretary: {
    searchDoctor: "Search doctor by name, specialty...",
    totalAssigned: "Total assigned",
    searchPatientEmail: "Search patient by email",
    patientName: "Patient name *",
    searchEmailPlaceholder: "Enter email or part of email",
    patientEmailPlaceholder: "Patient email",
    patientNamePlaceholder: "Patient full name",
    availableDoctors: "Available doctors",
    sharedSchedules: "Shared schedules",
    specialties: "Specialties",
    assign: "Assign",
    overbooking: "Overbooking",
    limitations: "Limitations",
    manageAppointments: "Manage appointments for patients",
    whatYouCanDo: "What can you do?",
    viewSharedSchedules: "View schedules that doctors have shared with you",
    assignFromSlots:
      "Assign appointments from available slots or overbookings in occupied times",
    viewRealtimeAvailability: "View real-time availability",
    onlySharedWithYou: "You can only view schedules shared specifically with you",
    cannotSeePrivate:
      "You cannot view existing private or insurance appointments",
    cannotModifySchedules: "You cannot modify the doctor's schedules",
    overbookingHint:
      "For occupied slots, you can assign an overbooking from the corresponding button",
    assignOverbookingTitle: "Assign overbooking in this time slot",
  },
  commonUi: {
    error: "Error",
    search: "Search",
    importantInfo: "Important Information",
    sending: "Sending...",
    sendInstructions: "Send instructions",
    searching: "Searching...",
    searchPlaceholder: "Search...",
    add: "Add",
  },
  insurance: {
    groupPrepaid: "Prepaid plans",
    groupSocial: "Social health insurance",
    none: "No coverage / Select",
    other: "Other (not listed)",
    otherPlaceholder: "Type the name of your coverage",
    remove: "Remove {{name}}",
    noneSelected:
      "You haven't selected any coverage yet: patients will only see your private appointments.",
    searchPlaceholder: "Search health insurance or prepaid plan...",
    acceptedTitle: "Health insurance and prepaid plans you accept",
    acceptedHint:
      "Patients will see in search results whether you accept their coverage. If you don't, they can only book your private appointments.",
  },
  booking: {
    loadingDoctors: "Loading doctors...",
    doctorNotFound: "Doctor not found",
    selectedSlot: "Selected appointment:",
    fullName: "Full name *",
    fullNamePlaceholder: "Enter your full name",
    phone: "Phone",
    countryCode: "Code",
    phonePlaceholder: "e.g. 555 123-4567",
    reason: "Reason *",
    reasonPlaceholder: "Reason for visit, observations, etc.",
    bookingFor: "Who is the appointment for?",
    forMyself: "For myself",
    privateOnlyInsurance:
      "This professional does not accept {{insurance}}: only private-pay days and times are shown.",
    privateOnlyNoInsurance:
      "You have no health coverage on file: only the professional's private-pay days and times are shown.",
  },
  dependents: {
    title: "Family members",
    intro:
      "Register your children or family members so you can book appointments on their behalf.",
    add: "Add family member",
    addTitle: "Add family member",
    editTitle: "Edit family member",
    name: "First name *",
    lastName: "Last name *",
    dni: "ID number",
    birthDate: "Date of birth",
    relationship: "Relationship",
    relSelect: "Select…",
    relChild: "Child",
    relSpouse: "Spouse",
    relParent: "Parent",
    relSibling: "Sibling",
    relOther: "Other",
    healthInsurance: "Health insurance",
    healthInsuranceNumber: "Member number",
    created: "Family member added",
    updated: "Family member updated",
    saveError: "Error saving the family member",
    deleted: "Family member removed",
    deleteError: "Error removing",
    deleteTitle: "Remove family member",
    deleteConfirm:
      "Are you sure you want to remove {{name}}? Their already booked appointments are not cancelled automatically.",
    delete: "Remove",
    deleting: "Removing…",
    loadError: "Could not load family members.",
    emptyState:
      "You haven't added any family members yet. Use the button above to add the first one.",
  },
  acting: {
    operatingWith: "Operating with",
    myself: "Me",
    myselfCaption: "Account holder",
    title: "Who do you want to operate with?",
    addAndSelect: "It will be added and selected to operate.",
  },
  waitingRoom: {
    title: "Patient Reception",
    subtitleDoctor: "Patients checked in at reception — Dr. {{name}} {{lastName}}",
    subtitleSecretary: "Patient arrival management — {{name}} {{lastName}}",
    patientsInReception: "Patients in reception",
    dailyAppointments: "Today's appointments",
    inWaitingRoom: "In reception",
    inReceptionBadge: "In reception",
    markPresent: "Mark present",
    present: "Present",
    private: "Private",
    firstAppointment: "First appointment",
    search: "Search by patient, doctor, or time...",
    doctor: "Doctor:",
    reason: "Reason:",
    nextAppointment: "Next appointment",
    patientsWaiting: "Patients waiting",
    emptyNoPatients: "No patients in reception",
    emptyNoPatientsHint:
      "Patients will appear here when the secretary marks them as present",
  },
  studies: {
    commentPlaceholder: "e.g. Lumbar MRI April 2026, requested by orthopedics…",
    uploaded: "Uploaded:",
    comment: "Comment",
    confirmDelete: "Delete this study? The image will no longer appear on your profile.",
    saveError: "Error saving study",
    updateError: "Error updating",
    deleteError: "Error deleting",
    uploadError: "Error uploading image",
    pageIntro:
      "Upload photos or screenshots of your medical studies and add a note for context. Images are stored securely via imgBB.",
    uploadTitle: "Upload new study",
    imageLabel: "Image",
    chooseFile: "Choose file",
    previewAlt: "Preview",
    commentOptional: "Comment (optional)",
    uploading: "Uploading…",
    saveStudy: "Save study",
    loadError:
      "Could not load your studies. If the problem persists, contact support.",
    emptyState:
      "You haven't uploaded any studies yet. Use the form above to add your first one.",
    yourStudies: "Your studies ({{count}})",
    studyAlt: "Study",
    savingComment: "Saving…",
    saveComment: "Save comment",
    delete: "Delete",
  },
  users: {
    confirmDelete: "Are you sure you want to delete this user?",
    copied: "Copied!",
    title: "Users",
    viewDetail: "View details",
    copyInvite: "Copy invitation",
    edit: "Edit",
    delete: "Delete",
  },
  payments: {
    title: "Payment details",
    successTitle: "Payment successful!",
    successBody: "Your payment was completed successfully. Thank you for your purchase. If you have any questions, please contact us.",
    pendingTitle: "Payment pending!",
    pendingBody: "Your payment is being processed. Please wait while we confirm your transaction. If it doesn't complete soon, try again or contact support.",
    failureTitle: "Payment failed!",
    failureBody: "Your payment was not completed. Please try again or contact support if the problem persists.",
    payWithMp: "Pay with Mercado Pago",
    mpRequestError: "Request error",
    mpPaymentUrlError: "Could not get payment URL",
    mpProcessError: "An error occurred while processing the payment. Please try again.",
    sampleProduct: "Sample product",
    paymentFormTitle: "Payment details",
    paymentFormHint: "Enter the details to proceed with payment",
  },
  subscriptionSuccess: {
    title: "Subscription created successfully!",
    body: "Your subscription has been set up correctly. Payments will be processed automatically according to your billing cycle.",
    hint: "You can manage your subscription from your profile at any time.",
    viewSubscription: "View my subscription",
    goHome: "Go to home",
  },
  invite: {
    title: "Invitation",
    enterPassword: "Enter a password",
    required: "* Required",
    setPassword: "Set password",
  },
  landing: {
    loadingInstitution: "Loading institution information...",
    loadingAssociation: "Loading association information...",
    medicalInstitution: "Medical institution",
    medicalCenter: "Medical center",
    professionalAssociation: "Professional association",
    memberSince: "Member since",
    associatedProfessionals: "Associated professionals",
    subscribedProfessionals: "Subscribed professionals",
    subscribed: "Subscribed",
  },
  afip: {
    title: "AFIP configuration",
    subtitle: "Set up your credentials for electronic invoicing",
    back: "Back",
    activeSince: "Active configuration since",
    certExpires: "Certificate expires:",
    tabConfig: "Configuration",
    tabInstructions: "Instructions",
    fiscalData: "Tax information",
    commercialAddress: "Business address *",
    technicalConfig: "Technical configuration",
    businessName: "Business name *",
    businessNamePlaceholder: "Dr. John Smith",
    vatCondition: "VAT condition",
    registeredTaxpayer: "Registered taxpayer",
    monotax: "Monotax taxpayer",
    exempt: "Exempt",
    addressPlaceholder: "123 Main St, City",
    salesPoint: "Sales point",
    environment: "Environment",
    testingEnv: "Testing (sandbox)",
    production: "Production",
    certExpiry: "Certificate expiry *",
    productionWarning:
      "Production mode: invoices will be real and reported to AFIP",
    certificatesTitle: "AFIP certificates",
    certificatesDesc:
      "Upload your certificates obtained from AFIP. Files are stored securely and encrypted.",
    certificateLabel: "Certificate (.crt or .pem) *",
    privateKeyLabel: "Private key (.key or .pem) *",
    certificateConfigured: "Certificate configured",
    privateKeyConfigured: "Private key configured",
    certificatesStorageNote:
      "Certificates are stored encrypted in the database. Only upload new files if you need to update them.",
    saving: "Saving...",
    updateConfig: "Update configuration",
    saveConfig: "Save configuration",
    testConnection: "Test connection",
    fileExtension: "File must have extension {{extensions}}",
    extensionOr: " or ",
    fileTooLarge: "File cannot exceed 1MB",
    cuitInvalid: "CUIT must have 11 digits",
    businessNameRequired: "Business name is required",
    addressRequired: "Business address is required",
    certificateRequired: "Certificate is required",
    privateKeyRequired: "Private key is required",
    expiryRequired: "Expiry date is required",
    saveSuccess: "AFIP configuration saved successfully",
    saveError: "Error saving configuration. Please try again.",
    saveBeforeTest: "Save the configuration before testing the connection",
    connectionSuccess: "Successful connection to AFIP",
    connectionError: "Error connecting to AFIP",
    testConnectionError: "Error testing connection",
    instructionsTitle: "How to obtain AFIP certificates",
    instructionsDesc:
      "Follow these steps to obtain your electronic invoicing certificates",
    step1Title: "Step 1: Access AFIP",
    step1Intro: "Go to",
    step1WithCredentials: "with your CUIT and Fiscal Key",
    step2Title: "Step 2: Fiscal Key Relationship Manager",
    step2Body:
      'Go to "Fiscal Key Relationship Manager" → "Digital Certificates"',
    step3Title: "Step 3: Generate certificate",
    step3Item1: 'Select "Generate new certificate"',
    step3Item2: 'Choose "Certificate for applications"',
    step3Item3: "Complete the requested information",
    step3Item4: "Download the .p12 file",
    step4Title: "Step 4: Convert certificate",
    step4Body: "Use OpenSSL to convert the .p12 file to the required formats:",
    step4CommandCert: "# Extract certificate (.crt)",
    step4CommandKey: "# Extract private key (.key)",
    step5Title: "Step 5: Configure in the application",
    step5Item1: "Upload the certificado.crt file",
    step5Item2: "Upload the clave_privada.key file",
    step5Item3: "Complete tax information",
    step5Item4: "Test the connection",
    keepCertsSafe:
      "Keep your certificates secure and do not share them. The application stores them encrypted for your security.",
    requiredServicesTitle: "Required AFIP services",
    requiredServicesIntro:
      "Make sure the following services are enabled in AFIP:",
    requiredService1: "Online Invoices - Electronic Invoice",
    requiredService2: "Electronic Invoicing Web Service",
    requiredService3: "Web Services Authentication and Authorization",
  },
};
